import React from "react";
import { toast } from "react-toastify";

import Slider from "src/components/slider";
import Button from "src/components/button";
import Toast from "src/components/toast";
import Text from "src/components/text";

import { getStorageDetails } from "src/utils/dataSource.helper";
import { formatDate } from "src/utils/helper";
import { useDeleteDataSource } from "src/query/settings/dataSource";

import styles from "./styles.module.scss"

interface DeleteDataSourceProps {
  show: boolean;
  onClose: () => void;
  item: any;
  label: string;
  date: string;
}

const DeleteDataSource: React.FC<DeleteDataSourceProps> = ({ show, onClose, item, label, date}) => {

  const deleteMutation = useDeleteDataSource();

  const image = getStorageDetails(item?.storageType) || {};

  const handleConfirm = () => {
    if (!item?.id) return;

    deleteMutation.mutate(
      { id: item.id },
      {
        onSuccess: () => {
          toast(
            <Toast.Sucess
              heading="Data Source Deleted"
              message={`The data source “${item?.name}” has been successfully deleted.`}
            />
          );
          onClose();
        },
        onError: (error) => {
          console.error("Error deleting data source", error);
          toast(
            <Toast.Failure
              heading="Failed to Delete Source"
              message="Something went wrong. Please try again."
            />
          );
        },
      }
    );
  };

  return (
    <Slider.Dialog
      width="380"
      show={show}
      onClose={onClose}
      className={styles.container}
    >
      <Slider.Header title="delete source" message={`${item?.assets ?? 0} Assets`} />
      <Slider.Body>
        <div className={styles.body}>
          <div className={styles.description}>
            Are you sure you want to delete
            <span className={styles.highlightedText}> “{item?.name || "Unknown"}” </span> source?
            <span className={styles.highlightedText}> “{item?.assets ?? 0} {item?.assets === 1 ? "asset" : "assets"}” </span>
            will be deleted, this step cannot be undone.
          </div>
          <div className={styles.dataSourceInfo}>
            {image && <img src={image.image} alt={image.name} className={styles.icon} />}
            <div className={styles.item}>
              <Text text={item?.name || "Unknown"} className={styles.name} lines={1} />
              <div className={styles.metadata}>
                <span>{`${item?.assets ?? 0} Assets`}</span>
                <span> {label} {formatDate(date)} </span>
              </div>
            </div>
          </div>

        </div>
      </Slider.Body>
      <Slider.Actions>
        <Button
          icon="paperflite-tick"
          variant="primary"
          onClick={handleConfirm}
          text={deleteMutation.isPending ? "Deleting..." : "Confirm"}
          disabled={deleteMutation.isPending}
        />
        <Button onClick={onClose} text="Cancel" />
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default DeleteDataSource;